<template>
  <v-container fluid>
    <v-btn class="mb-2" text small @click="$router.push({ name: 'adminDropdownList' })" data-cy="returnToListBtn">
      <v-icon class="mr-2" small>fas fa-arrow-left</v-icon>Return to Dropdown List
    </v-btn>
    <div class="d-flex align-end mb-5">
      <h1 class="font-weight-thin" data-cy="dropdownHeading">{{ dropdownLabel }} Dropdown</h1>
      <v-btn class="ma-3" color="primary" x-small text @click="showEditForm = true" data-cy="editBtn"
        ><v-icon class="mr-1" small>fas fa-edit</v-icon>Edit Label</v-btn
      >
    </div>
    <div>
      <v-dialog v-model="showEditForm" persistent max-width="600px">
        <v-card>
          <v-card-title class="headline font-weight-thin">
            Edit Dropdown Label
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-card-text>
                <v-text-field
                  :rules="labelRules"
                  clearable
                  data-cy="dropdownLabel"
                  label="Label"
                  required
                  v-model="dropdown.label"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" outlined small data-cy="cancel">Cancel</v-btn>
                <v-btn @click="save" :disabled="!valid" outlined small color="primary" data-cy="save">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div v-if="dropdownValueList">
        <AdminDropdownValueList
          :dropdown="dropdownOriginal"
          :dropdownValueList="dropdownValueList"
        ></AdminDropdownValueList>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AdminDropdownValueList from "./AdminDropdownValueList";

export default {
  components: {
    AdminDropdownValueList,
  },
  computed: {
    dropdownValueList() {
      return this.dropdownValueList;
    },
    ...mapGetters({ getDropdownById: "admin/dropdown/getById" }),
    ...mapState({
      dropdown: state => state.admin.dropdown.edit,
      dropdownList: state => state.admin.dropdown.list,
      dropdownOriginal: state => state.admin.dropdown.record,
      dropdownValueList: state => state.admin.dropdownValue.listWithReleaseNotes,
    }),
  },
  async created() {
    try {
      await Promise.all([this.fetchDropdown(this.id), this.fetchDropdownList(), this.fetchDropdownValueList(this.id)]);
      this.dropdownLabel = this.dropdown.label;
    } catch (e) {
      console.error(e);
      this.$notifyError("Error fetching dropdown data.");
    }
  },
  data() {
    return {
      dropdownLabel: null,
      labelRules: [label => !!label || "Label is required"],
      showEditForm: false,
      valid: true,
    };
  },
  methods: {
    async cancel() {
      this.resetEdit(this.dropdownOriginal);
      this.showEditForm = false;
    },
    async save() {
      try {
        await this.updateDropdown(this.dropdown);
        this.dropdownLabel = this.dropdown.label;
        this.showEditForm = false;
        this.$notifySuccess("Successfully updated dropdown label.");
      } catch (e) {
        console.error(e);
        return this.$notifyError("There was an error updating dropdown label.");
      }

      try {
        await Promise.all([this.fetchDropdown(this.id), this.fetchDropdownList()]);
      } catch (e) {
        console.error(e);
        this.$notifyError("Error refreshing data");
      }
    },
    ...mapActions({
      fetchDropdown: "admin/dropdown/fetchRecord",
      fetchDropdownList: "admin/dropdown/list",
      fetchDropdownValueList: "admin/dropdownValue/listWithReleaseNotes",
      updateDropdown: "admin/dropdown/update",
      resetEdit: "admin/dropdown/resetEdit",
    }),
  },
  props: ["id"],
};
</script>
